import { render, staticRenderFns } from "./EditorSection.vue?vue&type=template&id=56be128a&scoped=true&"
import script from "./EditorSection.vue?vue&type=script&lang=ts&"
export * from "./EditorSection.vue?vue&type=script&lang=ts&"
import style0 from "./EditorSection.vue?vue&type=style&index=0&id=56be128a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be128a",
  null
  
)

export default component.exports